import callApi from '@niarab2c/frontend-commons/src/util/callApi';
import type { Storefront } from '@niarab2c/otabuilder-crudmodel/src';
import queryString from 'query-string';
export type StorefrontWithTenantId = Storefront & {
  tenantId: string;
};
const PREVIEW_MODE = function (): boolean {
  if (location && location.search && location.search.indexOf('PREVIEW_MODE') >= 0) {
    sessionStorage.setItem('PREVIEW_MODE', 'true');
    return true;
  }
  try {
    return !!sessionStorage.getItem('PREVIEW_MODE');
  } catch {
    return false;
  }
  return false;
}();

/**
 * @deprecated
 */
const PREFIXED_DEFAULT_URL = /([\w-]+)\.travel365marketplace\.com$/;
const DEFAULT_URL = process.env.NODE_ENV === 'development' ? /(localhost|bs-local\.com|(?:[0-9]{1,}.){3}[0-9]{1,})|\w{1,}.ngrok-free.app$/ : process.env.DEV_OR_HOMOLOG_OR_PROD === 'dev' ? /(app\.niarab2cdev\.niara\.tech|localhost|bs-local\.com)$/ : process.env.DEV_OR_HOMOLOG_OR_PROD === 'homolog' ? /(app\.niarab2chomolog\.niara\.tech)$/ : /(app\.otabuilder\.com)$/;
export const fetchStorefront = async (locator: string, locale?: string): Promise<StorefrontWithTenantId> => {
  if (!locator) return null;
  try {
    const storefront: StorefrontWithTenantId = (await callApi('otabuilder-backend', `/storefronts/${encodeURIComponent(locator)}`, 'get', {
      locale
    })) || (await callApi('otabuilder-backend', `/urls?${queryString.stringify({
      url: locator
    })}`, 'get', {
      locale
    }));
    return storefront;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return null;
  }
};
const loadStorefront = async (locale?: string): Promise<[StorefrontWithTenantId, boolean]> => {
  const [hostname, path] = [location.hostname, location.pathname?.split('/')[1]];
  return new Promise((resolve, reject) => {
    // URL customizada com subdomínio (ex: www.meudominiocustomizado.com/localizadordapagina)
    if (PREFIXED_DEFAULT_URL.test(hostname)) {
      const prefixedUrlExec = PREFIXED_DEFAULT_URL.exec(hostname);
      fetchStorefront(prefixedUrlExec?.[1], locale).then(storefront => {
        if (storefront) {
          resolve([storefront, true]);
          return;
        } else {
          resolve([null, undefined]);
          return;
        }
      }).catch(err => {
        reject(err);
      });
    } else if (PREVIEW_MODE || DEFAULT_URL.test(hostname)) {
      // URL padrão - procurar storefront pelo path
      fetchStorefront(path, locale).then(storefront => {
        if (storefront) {
          resolve([storefront, false]);
          return;
        } else {
          resolve([null, undefined]);
          return;
        }
      }).catch(err => {
        reject(err);
      });
    } else if (path) {
      // URL customizada
      // suporte a custom domain com subdomínio (ex: www.meudominiocustomizado.com/localizadordapagina)
      fetchStorefront(`${hostname}/${path}`, locale).then(storefront => {
        if (storefront) {
          resolve([storefront, false]);
          return;
        } else {
          // não achou storefront mapeado para hostname/path - buscar de novo usando apenas hostname
          return fetchStorefront(`${hostname}`).then(storefront => {
            if (storefront) {
              resolve([storefront, true]);
              return;
            } else {
              resolve([null, undefined]);
            }
          });
        }
      }).catch(err => {
        reject(err);
      });
    } else {
      fetchStorefront(`${hostname}`, locale).then(storefront => {
        if (storefront) {
          resolve([storefront, true]);
          return;
        } else {
          resolve([null, undefined]);
        }
      }).catch(err => {
        reject(err);
      });
    }
  });
};
const loadStorefrontWithCache = async (locale?: string): Promise<[StorefrontWithTenantId, boolean]> => {
  if (window?.['_OTABUILDER_CACHED_STOREFRONT_' + locale]) return window['_OTABUILDER_CACHED_STOREFRONT_' + locale];
  return loadStorefront(locale).then(res => {
    window['_OTABUILDER_CACHED_STOREFRONT_' + locale] = res;
    return res;
  });
};
export default loadStorefrontWithCache;